// extracted by mini-css-extract-plugin
module.exports = {"message":"DeliveryHighlightMessage_message__7sxRF","deliveryMessage":"DeliveryHighlightMessage_deliveryMessage__6hSYm"};